var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-textbox"},[_c('label',{staticClass:"r-textbox--label",attrs:{"for":"$attrs.name"}},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"r-textbox--inner-wrapper"},[_c('input',_vm._b({staticClass:"r-textbox--input",class:{
        disabled: _vm.disabled,
        error: _vm.error,
      },attrs:{"type":_vm.$attrs.type ? _vm.$attrs.type : 'text',"name":_vm.$attrs.name,"disabled":_vm.disabled},on:{"input":_vm.onInput}},'input',_vm.$attrs,false)),_c('span',{staticClass:"r-textbox-unit"},[_vm._v(_vm._s(_vm.unit))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }